// extracted by mini-css-extract-plugin
export var ceTeamGridWrapper = "TeamGrid-module--ce-team-grid-wrapper--95e54";